<div class='header-line' fxLayout fxLayoutAlign='space-between center'>
  <div fxLayout fxLayoutAlign='start center'>
    <ng-template #descriptionTemplate>
      <div class="description-template" [innerHTML]="formatInnerText(cardDescription | linkify)"></div>
    </ng-template>

    <div class='table-title'>{{ dashboardTitle }}</div>

    <mat-icon
      class="info-icon"
      [matTooltip]="'OPEN_DESCRIPTION' | translate"
      [matTooltipPosition]="'above'"
      (click)='openDescription(descriptionTemplate)'
    >info</mat-icon>

    <app-filter-bar
      *ngIf='initDates'
      [filters]="['dateRange']"
      [initialValue]='initDates'
      [smallNewDateRange]="true"
      [preventFiltersStore]="true"
      (filterChanges)="onFilterChanges($event)"
    ></app-filter-bar>
  </div>
</div>

<div class="progress-bar-wrapper">
  <mat-progress-bar *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
</div>

<ng-container *ngIf="!isLoading">
  <div *ngFor="let group of metricGroups" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="32px">
    <app-month-weeks-interest-table
      *ngIf="group.node.metricGroup.metricvalueSet.edges.length"
      [group]="group.node.metricGroup"
      [groupBy]="'week'"
    ></app-month-weeks-interest-table>
    <app-month-weeks-interest-table
      *ngIf="group.node.metricGroup.metricvalueSet.edges.length"
      [group]="group.node.metricGroup"
      [groupBy]="'month'"
    ></app-month-weeks-interest-table>
  </div>
</ng-container>
